import { ComparisonModes } from '@/entities/market-intel/model/types';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetAvgDaysToResolveRequestDtoSchema = z.object({
  facilityId: z.number(),
  comparisonSet: z.enum(ComparisonModes),
  from: z.string(),
  to: z.string(),
});

const GetAvgDaysToResolveResponseDtoSchema = z.object({
  currentValue: z.number().nullable(),
  hint: z.string(),
  marketMedian: z.number().nullable(),
  message: z.string(),
});

export type GetAvgDaysToResolveRequestDto = z.infer<
  typeof _GetAvgDaysToResolveRequestDtoSchema
>;
export type GetAvgDaysToResolveResponseDto = z.infer<
  typeof GetAvgDaysToResolveResponseDtoSchema
>;

export const getAvgDaysToResolve = (
  params: GetAvgDaysToResolveRequestDto,
  config?: AxiosRequestConfig<GetAvgDaysToResolveRequestDto>
) => {
  const { facilityId, ...queryParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/avg-days-to-resolve`, {
      params: queryParams,
      ...config,
    })
    .then(responseContract(GetAvgDaysToResolveResponseDtoSchema));
};
